<ng-container *ngIf="!showLoaderPhases; else loaderTemplate">
  <form [formGroup]="form" class="forms">
    <div class="row info-container white-box">
      <h2>Informações do Vendedor</h2>
      <h4>
        Selecione seu e-mail na lista de vendedores, caso não o encontre, ou
        seja, essa é a sua primeira vez utilizando o Omni+ realize o cadastro.
      </h4>

      <div class="form-group">
        <span class="icon vendedor"></span>
        <div class="inputs" (click)="dropDownClick()">
          <label for="vendedor">Identificação do Vendedor</label>
          <app-auto-complete
            formControlName="vendedor"
            name="vendedor"
            required="true"
            [items]="vendedores"
            [key]="vendedorKey"
            [label]="vendedorLabel"
            [addModalForm]="addModalForm"
            [addModalConfig]="modalConfig"
            requiredMessage="Selecionar o vendedor é obrigatório"
            (add)="onAddVendedor($event)"
          ></app-auto-complete>
          <span *ngIf="errorMessage">{{ errorMessage }}</span>
        </div>
      </div>
    </div>

    <div>
      <div class="row info-container white-box">
        <h2>Informações do financiamento</h2>
        <h4>
          Nesta etapa insira o valor do produto a ser financiado e o CPF do
          cliente para a validação das condições especiais de financiamento para
          esse perfil de cliente.
        </h4>

        <div class="form-group">
          <span class="icon dinheiro"></span>

          <div class="inputs">
            <div class="d-inline-flex">
              <label for="valorSolicitado">Valor Solicitado</label>
            </div>

            <input
              class="form-control"
              type="text"
              placeholder="R$ 00.000,00"
              maxlength="17"
              required
              appShowErrorMessages
              requiredMessage="O campo Valor solicitado é obrigatório"
              formControlName="valorSolicitado"
              name="valorSolicitado"
              mask-money
              [prefix]="'R$'"
              appMoedaValidator
              valorMinimoMessage="Valor mínimo permitido R$"
              appOnlyNumberRestrictive
              [valorMaximo]="parametroRendaProduto.valorSolicitadoMaximo"
              [valorMinimo]="parametroRendaProduto.valorSolicitadoMinimo"
            />
          </div>
        </div>
        <div class="form-group">
          <span class="icon documento"></span>

          <div class="inputs">
            <div class="d-inline-flex">
              <label for="cpf">CPF do Cliente</label>
            </div>

            <input
              class="form-control"
              type="text"
              placeholder="000.000.000-00"
              required
              mask-number
              [mask]="'999.999.999-99'"
              appCpfValidator
              appShowErrorMessages
              requiredMessage="O campo CPF é obrigatório"
              formControlName="cpf"
              name="cpf"
            />
          </div>
        </div>
      </div>
    </div>
  </form>

  <app-botao-navegacao
    *ngIf="!showTryAgainButton"
    (previous)="onClickPrevious()"
    (next)="onClickNext()"
    [previousShow]="true"
    [nextShow]="true"
    [nextEnabled]="form.valid"
    nextLabel="Simular"
  ></app-botao-navegacao>

  <div class="btn-analisar-novamente">
    <button
      *ngIf="showTryAgainButton"
      class="bt-go btn btn-full-orange"
      (click)="onClickTryAgain()"
      [disabled]="!form.valid"
    >
      Analisar novamente
    </button>
  </div>

  <app-loader-circles *ngIf="showLoader"></app-loader-circles>
</ng-container>

<ng-template #loaderTemplate>
  <div class="loader-phases">
    <app-loader-phases
      [phases]="['Aguarde, validando informações.']"
    ></app-loader-phases>
  </div>
</ng-template>
